export default {
  formulaFactors: {
    table: {
      sortNo: '行号',
      factorCode: '因子编码',
      factorName: '因子名称',
      factorStatus: '因子状态',
    },
    msg: {
      disable: '禁用',
      enable: '启用',
      enableConfirm: '启用确认',
      disableConfirm: '禁用确认',
      isEnable: '是否启用',
      isDisable: '是否禁用',
    },
  },
  computationalFormula: {
    table: {
      sortNo: '行号',
      balanceType: '余额类型',
      formulaExpression: '计算公式',
      formulaStatus: '状态',
    },
    msg: {
      effective: '有效',
      ineffective: '无效',
      disable: '禁用',
      enable: '启用',
      enableConfirm: '启用确认',
      disableConfirm: '禁用确认',
      isEnable: '是否启用',
      isDisable: '是否禁用',
      formulaExpression: '计算公式不能为空',
      formulaExpressionRules: '只能输入已有的公式因子和+-*/()',
    },
  },
  customerBalanceAdjust: {
    search: {
      businessCompanyCode: '业务公司编码',
      businessCompanyName: '公司',
      partnerName: '客户名称',
      balanceType: '余额类型',
      docNo: '单据编号',
      operaterName: '制单人',
      operaterStartDate: '制单日期从',
      operaterEndDate: '制单日期至',
      docStatus: '单据状态',
      effectiveStartDate: '生效日期从',
      effectiveEndDate: '生效日期至',
      remark: '备注',
    },
    column: {
      businessCompanyCode: '业务公司编码',
      businessCompanyName: '公司',
      docNo: '单据编号',
      operaterName: '制单人',
      operaterDate: '制单日期',
      docStatus: '单据状态',
      effectiveDate: '生效日期',
      partnerName: '客户名称',
      remark: '备注',
    },
    collapseTitle: {
      basicTitle: '基本信息',
      detailTitle: '调整行',
    },
    placeholder: {
      auto: '自动生成',
    },
    table: {
      sortNo: '行号',
      businessCompanyName: '公司',
      docNo: '单据编号',
      operaterName: '制单人',
      operaterDate: '制单日期',
      docStatus: '单据状态',
      effectiveDate: '生效日期',
      balanceType: '余额类型',
      partnerName: '客户名称',
      adjustAmount: '调整额',
      remark: '备注',
    },
    msg: {
      noSelectDel: '请选择一条数据进行操作',
      onlyCanSelectNoEdit: '只能选择一条数据进行修改',
      typeSelectEdit: '只有已保存状态可以修改',
      enableConfirm: '生效确认',
      isEnable: '是否生效',
      disableConfirm: '撤销确认',
      isDisable: '是否撤销',
      balanceTypePlaceholder: '余额类型不能为空',
      partnerNamePlaceholder: '客户名称不能为空',
      adjustAmountPlaceholder: '调整额不能为空',
      remarkPlaceholder: '备注不能为空',
      balanceTypeNoRepeat: '余额类型不能重复!',
    },
  },
  formulaBalance: {
    search: {
      businessCompanyCode: '业务公司编码',
      businessCompanyName: '公司',
      partnerName: '客户名称',
      balanceType: '余额类型',
    },
    table: {
      sortNo: '行号',
      businessCompanyCode: '公司代码',
      businessCompanyName: '公司名称',
      partnerCode: '客户代码',
      partnerName: '客户名称',
      balanceType: '余额类型',
      formulaAmount: '余额',
    },
  },
};
